import { Observable } from 'rxjs';
import type { DataPlaneInstance } from '../models/data-plane-instance.model';

/**
 * Stable domain contract for listing registered data plane instances of this connector.
 * Implemented by AdessoDataPlaneApiAdapter against the adesso-connector-api.
 */
export abstract class DataPlaneApiPort {
  abstract getDataPlanes(): Observable<DataPlaneInstance[]>;
}
